import React from 'react';
import cn from 'clsx';

import Typography from '../../../../library/typography/typography';

import styles from './pdp-free-services.scss';

interface Services {
  order: number;
  service: string;
}

interface PDPFreeServicesProps {
  className?: string;
  heading: string;
  services: Services[];
}

function sortByOrder(a, b) {
  return a?.order - b?.order;
}

function PDPFreeServices(props: PDPFreeServicesProps) {
  const { className, heading, services } = props;

  return (
    <div className={cn(styles['container'], className)}>
      <Typography tag="strong" weight="bold">
        {heading}
      </Typography>
      <div className={styles['services']}>
        <Typography tag="strong" variant="H6" weight="bold">
          FREE
        </Typography>
        <Typography tag="span" variant="H6" weight="medium">
          {Array.isArray(services) &&
            services.sort(sortByOrder).map(({ order, service }, i) => (
              <>
                {i > 0 && <span> / </span>}

                <span key={`fs-${order}`}>{service}</span>
              </>
            ))}
        </Typography>
      </div>
    </div>
  );
}

export default PDPFreeServices;
